import type { FeatureProps } from '@cxnpl/ui';
import { Feature, H1, H3, YStack, Text } from '@cxnpl/ui';
import { CheckCircle2 } from '@cxnpl/ui/icons';
import type { ReactNode } from 'react';

export interface ConfirmationSuccessDetailsProps {
  /** Title */
  title: string;
  /** Subheading */
  body?: string | ReactNode;
  /** Features title */
  featuresTitle?: string;
  /** Features  */
  features?: FeatureProps[];
}

export const ConfirmationSuccessDetails = ({
  title,
  body,
  featuresTitle,
  features,
}: ConfirmationSuccessDetailsProps) => {
  return (
    <YStack gap="$4xl">
      {/* Icon and Headers */}
      <YStack>
        <CheckCircle2 size="$5xl" color="$icon/success" />
        <H1 marginTop="$xl" marginBottom="$md">
          {title}
        </H1>
        {typeof body === 'string' ? (
          <Text variant="bodyMedium" maxWidth="100%">
            {body}
          </Text>
        ) : (
          body
        )}
      </YStack>
      {/* Features */}
      {(features && features.length > 0) || featuresTitle ? (
        <YStack gap="$2xl">
          {featuresTitle ? <H3>{featuresTitle}</H3> : null}
          {features && features.length > 0 ? (
            <YStack gap="$lg">
              {features.map((feature: FeatureProps) => {
                return (
                  <Feature
                    key={feature.title}
                    title={feature.title}
                    icon={feature.icon}
                    description={feature.description}
                  />
                );
              })}
            </YStack>
          ) : null}
        </YStack>
      ) : null}
    </YStack>
  );
};
